import {languageProcessing} from '@axyseo/index.js';
const {AbstractResearcher} = languageProcessing;

// All config
import firstWordExceptions from './config/firstWordExceptions';
import {all as functionWords} from './config/functionWords';
import transitionWords from './config/transitionWords';
import twoPartTransitionWords from './config/twoPartTransitionWords';
import syllables from './config/syllables.json';
import fleschReadingEaseScores from './config/fleschReadingEaseScores';
import sentenceLength from './config/sentenceLength';

// All helpers
import getStemmer from './helpers/getStemmer';
import isPassiveSentence from './helpers/isPassiveSentence';
import fleschReadingScore from './helpers/calculateFleschReadingScore';

/**
 * The researcher contains all the researches, helpers, data, and config.
 */
export default class Researcher extends AbstractResearcher {
  /**
   * Constructor
   * @param {Paper} paper The Paper object that is needed within the researches.
   * @constructor
   */
  constructor(paper) {
    super(paper);

    Object.assign(this.config, {
      language: 'ru',
      passiveConstructionType: 'morphological',
      firstWordExceptions,
      functionWords,
      transitionWords,
      twoPartTransitionWords,
      syllables,
      fleschReadingEaseScores,
      sentenceLength
    });

    Object.assign(this.helpers, {
      getStemmer,
      isPassiveSentence,
      fleschReadingScore
    });
  }
}
